import uc from '@/api/uc.js';
const state = {
	tenantCode: null,
	tenantSetting: null,
};

const getters = {};

const actions = {
	loadTenantSetting({ commit, state }, tenantCode) {
		return new Promise((resolve, reject) => {
			tenantCode = tenantCode ? tenantCode : state.tenantCode;
			uc.getTenantByCode(tenantCode).then(rep => {
				commit('setTenantCode', rep.data.code);
				commit('setTenantSetting', rep.data);
				resolve(rep);
			});
		});
	},
	setTenantCode({ commit, state }, tenantCode) {
		commit('setTenantCode', tenantCode);
	},
};

const mutations = {
	setTenantSetting(state, tenantSetting) {
		state.tenantSetting = tenantSetting;
	},
	setTenantCode(state, tenantCode) {
		state.tenantCode = tenantCode;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
